// This file is updated with the version on build
// Don't edit unless you are sure what you are doing
import { WindowKeys, WindowManagement } from "@services/windowManagement";

WindowManagement.saveObject(WindowKeys.VERSION, "45.1.10");
